var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.781,
    height: 18.151,
    viewBox: "0 0 21.781 18.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M21.781,6.124a5.848,5.848,0,0,1-.813,1.166A5.99,5.99,0,0,1,19.5,8.528q.024.194.036.364a13.214,13.214,0,0,1-.935,5.063,13.33,13.33,0,0,1-5.306,6.593,13.953,13.953,0,0,1-8.3,1.518A9.542,9.542,0,0,1,0,20.135a9.3,9.3,0,0,0,6.653-1.918,4.584,4.584,0,0,1-4.225-3.132,2.846,2.846,0,0,0,.947.049,8.771,8.771,0,0,0,1.068-.146,5.01,5.01,0,0,1-3.035-2.355A5.077,5.077,0,0,1,.9,10.4,4.269,4.269,0,0,0,2.914,11,5.208,5.208,0,0,1,.935,7.787a5.957,5.957,0,0,1,.546-2.9A15.274,15.274,0,0,0,6.666,8.771a10.732,10.732,0,0,0,4.067.85,5.436,5.436,0,0,1,.546-3.448,4.7,4.7,0,0,1,2.8-2.04A4.14,4.14,0,0,1,18.236,5.42a7.392,7.392,0,0,0,2.89-1.068,4.384,4.384,0,0,1-1.991,2.574,12.592,12.592,0,0,0,2.647-.8Z",
    transform: "translate(0 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6d094ee43ff009f15979dc6849ed370c.svg";
export { ForwardRef as ReactComponent };